var _path, _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOneDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_13540",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 32,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82979 26C3.50549 26 0 22.5675 0 18.3333C0 14.1921 3.35322 10.8179 7.54613 10.6716C9.27535 7.87166 12.4144 6 16 6C20.6308 6 24.5169 9.12183 25.5829 13.3335C29.1316 13.3603 32 16.1855 32 19.6667C32 23.0527 29 26 25.8723 25.9914L7.82979 26Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_13540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.82978 26C5.37785 26 3.18918 24.8965 1.75352 23.1689L18.0425 16.3334L30.7085 23.4646C29.5922 24.921 27.9063 26 26 25.9914C23.125 26 12.0625 26 7.82978 26Z",
    fill: "url(#paint0_linear_1_13540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5781 13.3148L18.0425 16.3333L30.7085 23.4645C31.5195 22.4063 32 21.0915 32 19.6667C32 16.1855 29.1316 13.3603 25.5829 13.3335C25.5813 13.3272 25.5797 13.321 25.5781 13.3148Z",
    fill: "url(#paint1_linear_1_13540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06472 10.7028L18.0426 16.3333L25.5781 13.3148C24.5054 9.11261 20.624 6 16 6C12.4144 6 9.27535 7.87166 7.54613 10.6716C7.38436 10.6773 7.22384 10.6877 7.06472 10.7028Z",
    fill: "url(#paint2_linear_1_13540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7535 23.1689L18.0425 16.3333L7.06471 10.7028C3.09947 11.0794 0 14.3519 0 18.3333C0 20.1667 0.657197 21.8497 1.7535 23.1689Z",
    fill: "url(#paint3_linear_1_13540)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_13540",
    x1: 4.42552,
    y1: 24.6667,
    x2: 27.2305,
    y2: 23.2762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2086B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46D3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_13540",
    x1: 23.8298,
    y1: 19.6666,
    x2: 30.2104,
    y2: 15.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1694DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62C3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_13540",
    x1: 8.51064,
    y1: 7.33333,
    x2: 23.3338,
    y2: 15.9348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D3D78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#063B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_13540",
    x1: -0.340429,
    y1: 20,
    x2: 14.5634,
    y2: 14.4651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16589B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1464B7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneDrive);
export default __webpack_public_path__ + "static/media/OneDrive.e4067c891ffcdb9d0adcae60cc5e50ee.svg";
export { ForwardRef as ReactComponent };